import React from 'react';
import cn from 'classnames';
import {Listbox} from '@headlessui/react';
import {IOption} from './UIOption';

type Props = {
  option: IOption<boolean>
  first: boolean
  flat?: boolean
};

export default function UIListboxOption({
  option, first, flat = false,
}: Props) {
  const disabled = option.parent || option.disabled;
  return (
    <Listbox.Option key={option.id} value={option.value} disabled={disabled}>
      {({selected, active}) => (
        <div className={cn(
          {
            'bg-blue-table-hover': active && !option.parent,
            'text-black': !active,
            'text-gray-dark border-t border-gray-light': option.parent && !first,
            'cursor-pointer': !selected && !disabled,
            'cursor-default': selected,
            'pl-8': !option.parent && !flat,
          },
          'select-none relative py-2.5 pl-3 pr-4',
        )}>
          <span className={cn('block truncate', {
            'font-semibold': selected,
            'font-normal': !selected,
            'font-bold': option.parent,
          })}>
            {option.label}
          </span>
        </div>
      )}
    </Listbox.Option>
  );
}
